<template>
  <div @click="openWindow(permalink)" class="card-list-container">
    <div class="card-body-top">
      <img class="card-img" :src="image.url" :alt="image.alt" />
      <div class="card-eyebrow label-card-eyebrow">
        <a :href="topic.link">{{ topic.name }}</a>
      </div>
      <h3 class="card-title label-card-title">
        <a :href="permalink" v-html="title"></a>
      </h3>
    </div>
    <div class="card-tags label-card-tags">
      <div v-for="tag in tags" :key="tag.term_id" class="card-tag">
        <span
          ><span class="card-slash">/</span
          ><a :href="tag.link">{{ tag.name }}</a></span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "permalink", "posttype", "image", "topic", "tags"],
  setup(props) {
    const permalink = props.permalink;

    function openWindow(link) {
      window.open(link, "_self");
    }

    return { permalink, openWindow };
  },
};
</script>
